import Reveal from "./Reveal";
import {
  JasmineGarland,
  Diya,
  VineBranch,
  PalaceArch,
  BloomPair,
  FloralDivider,
  FloralLineArt,
} from "./Ornaments";

const DAY_ONE = [
  {
    key: "haldi",
    num: "Chapter I",
    name: "Haldi",
    quote: "Golden sunshine, marigold hues & a little beautiful chaos.",
    dress: "Yellow · Multicolour · Festive",
    orn: "bloom",
  },
  {
    key: "mehendi",
    num: "Chapter II",
    name: "Mehendi",
    quote: "An evening painted in henna, music, dancing & a little bit of magic.",
    dress: "Sage · Emerald · Mehendi Green",
    orn: "vine",
  },
];

const WEDDING = {
  key: "the-wedding",
  num: "Chapter III",
  name: "The Wedding",
  quote: "Where two stories become one, and forever finally begins.",
  dress: "Ethnic · Elegant · Festive",
};

function Ornament({ kind }) {
  if (kind === "bloom") {
    return (
      <div className="chapter-orn">
        <BloomPair width={110} />
      </div>
    );
  }
  if (kind === "vine") {
    return (
      <div className="chapter-orn">
        <VineBranch width={140} flip />
      </div>
    );
  }
  return null;
}

function Chapter({ c, rev }) {
  return (
    <article
      className={`chapter${rev ? " rev" : ""}${c.key === "the-wedding" ? " wed" : ""}`}
      data-testid={`chapter-${c.key}`}
    >
      <div className="chapter-meta">
        <span className="chapter-num serif">{c.num}</span>
        <span>{c.date}</span>
      </div>
      <div className="chapter-body">
        {c.key === "the-wedding" && (
          <div className="wed-arch">
            <PalaceArch width={88} />
            <div className="wed-diya">
              <Diya width={26} dur={5.8} />
            </div>
          </div>
        )}
        <Ornament kind={c.orn} />
        <h3 className="chapter-name serif">{c.name}</h3>
        <p className="chapter-quote">&ldquo;{c.quote}&rdquo;</p>
        <div className="chapter-dress">
          <span>Dress</span>
          {c.dress}
        </div>
      </div>
    </article>
  );
}

export default function Celebrations() {
  return (
    <section
      id="celebrations"
      className="celebrations"
      data-testid="celebrations-section"
    >
      <div className="celebrations-frame" aria-hidden="true">
        <span className="fdot fdot-tl" />
        <span className="fdot fdot-tr" />
        <span className="fdot fdot-bl" />
        <span className="fdot fdot-br" />
      </div>
      <div className="cele-gar" style={{ left: "3%" }}>
        <JasmineGarland rows={13} />
      </div>
      <div className="cele-gar" style={{ right: "3%" }}>
        <JasmineGarland rows={12} delay={0.6} dur={7.4} />
      </div>
      <div className="cele-fline fline-bl">
        <FloralLineArt width={180} />
      </div>
      <div className="cele-fline fline-tr">
        <FloralLineArt width={180} />
      </div>

      <Reveal>
        <div className="celebrations-head">
          <div>
            <div className="kicker">25 — 26 November 2026 · Kanpur</div>
            <h2 className="celebrations-title serif">The Celebrations</h2>
          </div>
          <div className="head-divider">
            <FloralDivider width={190} flowerFill="#f3ecdd" />
          </div>
        </div>
      </Reveal>

      <Reveal>
        <div className="day-head" data-testid="day-one-header">
          <span className="day-name serif">Day One</span>
          <span className="day-line" />
          <span className="day-date">25 November 2026</span>
        </div>
      </Reveal>

      {DAY_ONE.map((c, i) => (
        <Reveal key={c.key} delay={i * 0.06}>
          <Chapter c={{ ...c, date: "25 November 2026" }} rev={i === 1} />
        </Reveal>
      ))}

      <Reveal>
        <div className="day-head" data-testid="day-two-header">
          <span className="day-name serif">Day Two</span>
          <span className="day-line" />
          <span className="day-date">26 November 2026</span>
        </div>
      </Reveal>

      <Reveal>
        <Chapter c={{ ...WEDDING, date: "26 November 2026" }} />
      </Reveal>
    </section>
  );
}
